import { cn } from '@/lib/utils';

interface FooterProps {
  className?: string;
}

export function Footer({ className }: FooterProps) {
  const currentYear = new Date().getFullYear();
  const appVersion = import.meta.env.VITE_APP_VERSION || '2.1.0';

  return (
    <footer
      className={cn(
        'fixed bottom-0 left-0 right-0 z-40',
        'border-t border-border/80 bg-background/90 backdrop-blur-md supports-[backdrop-filter]:bg-background/75',
        'h-12 sm:h-14',
        'flex items-center justify-center',
        'px-2 sm:px-4',
        'text-xs sm:text-sm text-muted-foreground',
        className
      )}
    >
      <div className="flex flex-col sm:flex-row items-center justify-center w-full max-w-7xl gap-1 sm:gap-2">
        <p className="text-center">
          © {currentYear} UNICEF Salesforce Middleware.
          <span className="hidden sm:inline"> All rights reserved.</span>
          <span className="hidden sm:inline"> • Version {appVersion}</span>
        </p>
      </div>
    </footer>
  );
}

